// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling: rules for printing */

@media print {
  @page {
    size: auto;
    margin: 0 0 10mm 0;
  }
  html {
    font-size: 81.25% !important;
  }
}

/* pl added in @media print { body... } */
.removePaddingLeftBody {
  padding-left: 0 !important;
}

/* old pdf */
@media print {
  body {
    padding-left: 11mm;
  }
}

.page {
  width: 240mm;
  min-height: 287mm;
}

.pageFooter {
  width: 240mm;
  position: fixed;
  bottom: 0;
}

.coverFooter {
  z-index: 1;
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: white;
  height: 20mm;
}
`, "",{"version":3,"sources":["webpack://./css/print.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,yCAAyC;AACzC;EACE,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;AACd","sourcesContent":["/* Styling: rules for printing */\n\n@media print {\n  @page {\n    size: auto;\n    margin: 0 0 10mm 0;\n  }\n  html {\n    font-size: 81.25% !important;\n  }\n}\n\n/* pl added in @media print { body... } */\n.removePaddingLeftBody {\n  padding-left: 0 !important;\n}\n\n/* old pdf */\n@media print {\n  body {\n    padding-left: 11mm;\n  }\n}\n\n.page {\n  width: 240mm;\n  min-height: 287mm;\n}\n\n.pageFooter {\n  width: 240mm;\n  position: fixed;\n  bottom: 0;\n}\n\n.coverFooter {\n  z-index: 1;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background-color: white;\n  height: 20mm;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
